import router from '@/router';
import { store } from '@/store';
import moment from 'moment';

const maintain = {
    /**
     * 顯示系統維護公告
     * @param {*} page
     */
    check(page) {
        axios
            .post(apiUrl.Maintain, {
                InsCategory: router.currentRoute.value.params.type === 'car'? 'Car' : 'Motorcycle',
                Page: page,
            })
            .then((res) => {
                if (res.data.Code !== 200) {
                    return router.push({
                        name: 'Maintain',
                        params: { message: res.data.ErrMessage },
                    });
                }

                if (
                    res.data.Data &&
                    res.data.Data.Id
                ) {
                    let message = res.data.Data.SystemMessage;
                    message = `<div class="html-content">${message}</div>`;

                    if([5, 6].includes(page)){
                        store.commit('policy/setPaymentMaintainInfo', res.data.Data.SystemMessage);
                    }
                    else if (res.data.Data.MessageType === 2) {
                        store.commit('setAllowLeavePage', true);
                        store.commit('nav/setProp', {maintain: message});
                        return router.push({
                            name: 'Maintain',
                            params: { message },
                        });
                    } else if (res.data.Data.MessageType === 0) {
                        // 之前未顯示過公告
                        if (maintain.getCookie() !== res.data.Data.Id &&  /^[1-9]\d*$/.test(res.data.Data.Id)) {
                            document.cookie = DOMPurify.sanitize(
                                'maintain=' + res.data.Data.Id,
                                { KEEP_CONTENT: false }
                            );
                            store.commit('setDialog', {
                                type: 'remind',
                                text: message,
                                active: true,
                            });
                        }
                    } else {
                        store.commit('setDialog', {
                            type: 'remind',
                            text: message,
                            active: true,
                        });
                    }
                }
            });
    },
    /**
     * 讀取 cookie 的資料
     * @returns
     */
    getCookie() {
        const value = `; ${document.cookie}`;
        const parts = value.split('; maintain=');
        if (parts.length === 2)
            return parts
                .pop()
                .split(';')
                .shift();
    },
};

export default maintain;
